import React from 'react';
import { useParams } from 'react-router-dom';
import OpportunityForm from '../components/opportunities/OpportunityForm';

const EditOpportunity = () => {
  const { id } = useParams();
  
  return <OpportunityForm opportunityId={parseInt(id)} isEdit={true} />;
};

export default EditOpportunity;
